export default "__VITE_ASSET__nQHnGLb$__"